import { isSSR } from './platform'

export default function cache(vm, key, obj) {
  if (isSSR === true) return obj

  const k = `__tescache_${key}`
  return vm[k] === void 0
    ? (vm[k] = obj)
    : vm[k]
}

export function lazyCache(vm, key, fn) {
  if (isSSR === true) return fn()

  const k = `__tescache_${key}`
  return vm[k] === void 0
    ? (vm[k] = fn())
    : vm[k]
}
